/** @jsx h */

import  { Fragment } from 'preact';
import  TomSelect  from 'tom-select';
import { useRef, useEffect, useState } from 'preact/hooks';


const FilterTomSelect = ({
  facet,
  option,
  filterName,
  handleChange,
  pluginNamespace,
  isReset,
  triggerAjaxSubmit
}) => {
  const selectEl = useRef(null);

  useEffect(() => {
    if (selectEl.current.tomselect) {
      selectEl.current.tomselect.destroy();
    }
  }, [isReset]);

  useEffect(() => {
    const settings = {
      maxItems: null,
      persist: false,
      controlInput: null,
      maxOptions: null,
      openOnFocus: true,
      allowEmptyOption: true,
      placeholder: 'Wähle aus',
      hidePlaceholder: false,
      closeAfterSelect: true,
      plugins: {
        no_active_items: {},
        checkbox_options: {
          checkedClassNames: ['ts-checked'],
          uncheckedClassNames: ['ts-unchecked'],
        },
        remove_button: {
          title: 'Entferne das item',
          label: `<svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.66693 5.50028L0.000570296 9.16664L1.3339 10.5L5.00026 6.83361L8.66664 10.5L9.99997 9.16667L6.33359 5.50028L10.0005 1.83333L8.66721 0.5L5.00026 4.16696L1.33333 0.500027L0 1.83336L3.66693 5.50028Z" fill="white"/>
                  </svg>`,
        },
      },
      render:{
        item: function(data, escape) {
          return "<div>" +
          `<input class="sr-only"
          id="${escape(data.id)}"
          type="checkbox"
          checked="${escape(data.checked)}"
          data-label="${escape(data.label)}"
          name="${escape(data.name)}"
          value="${data.value}"
          key="${escape(data.key)}">${escape(data.text)}</input>` + '</div>';
        },
      },
      onItemAdd: () => {
        triggerAjaxSubmit();
      },
      onItemRemove: () => {
        triggerAjaxSubmit();
      },
    };

    new TomSelect(selectEl.current, settings, {
    });
  }, [isReset]);

  return(
    <Fragment>
      <li class="search-template__selectfields-item">
        <div class="search-template__selectfields-text">{facet.label}</div>
        <div class="ts-select">
          <select ref={selectEl} class="ts-select__wrapper" autocomplete="off" >
            {facet.options.length
              ? facet.options.map(option => (
                <option {...(option.selected
                  ? { selected: "" }
                  : '')}
                  data-id={`${filterName}-${option.value}`}
                  data-text={`${option.label}`}
                  data-checked={option.selected}
                  data-label={`${filterName}-${option.label}`}
                  data-name={`${pluginNamespace}[filter][]`}
                  data-value={`${filterName}:${option.value}`}
                  data-key={option.value}>
                  {option.label}
                </option>
              ))
            : ''}
          </select>
        </div>
      </li>
    </Fragment>
  )
};

export default FilterTomSelect;
